export enum ModelApiEndpoints {
  listing_let_price = 'listing_let_price',
  listing_sell_price = 'listing_sell_price',
  time_to_sell = 'time_to_sell',
  sale_multiplier = 'sale_multiplier',
}
